import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      backgroundColor: '#fff',
      border: '1px solid var(--x-bg-9)',
      borderRadius: '50%',
      cursor: 'pointer',
      height: 48,
      width: 48,
    },
    icon: {
      fill: 'var(--x-black-1)',
      width: 24,
      height: 24,
    },
  },
  {
    name: 'IconRound',
  },
);

export default useStyles;
